import { inventories } from "@/api/inventories/useInventoriesQuery";
import { lots } from "@/api/lots/useLotsQuery";
import { useModal } from "@/features/modal/ModalStackManager";
import { ItemAutoComplete } from "@/features/ui/autoComplete/item/item-autoComplete";
import { LotAutoComplete } from "@/features/ui/autoComplete/lot/lot-autoComplete";
import styled from "@emotion/styled";
import { ItemsGet200ResponseRowsInnerItemTypeEnum } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLotTrackingActions } from "../../hook/useLotTrackingActions";
import { useLotTrackingState } from "../../hook/useLotTrackingState";

export const LotTrackingForwardActionHeader = () => {
  const { openModal } = useModal();
  const actions = useLotTrackingActions();
  const state = useLotTrackingState();
  const { t } = useTranslation();
  let tempLotId = "";

  const { data: lotData } = useQuery(
    lots.get({
      query: { $and: [{ itemCode: { $eq: state.itemCodeValue } }] },
    }),
  );

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      actions.setLotId(tempLotId);
    } else {
      tempLotId += e.key;
    }
  };

  const { data: inventory } = useQuery({
    ...inventories.get({
      query: {
        $and: [{ lotId: { $eq: state.lotId } }],
      },
    }),
    enabled: !!state.lotId,
  });

  useEffect(() => {
    const itemCode = inventory?.data?.rows?.[0]?.itemCode;

    if (state.lotId) {
      if (itemCode && state.itemCodeValue !== itemCode) {
        actions.setItemCodeValue(itemCode);
      }
    } else if (!state.lotId && state.itemCodeValue === itemCode) {
      actions.setItemCodeValue(null);
    }
  }, [state.lotId, inventory?.data?.rows?.[0]?.itemCode, state.itemCodeValue, actions]);

  const handleItemCodeChange = (value: string | null) => {
    actions.setItemCodeValue(value ?? "");

    if (!value) {
      actions.setLotId(""); // 품목이 비워지면 lotId도 초기화
    }
  };

  return (
    <ActionBarContainer>
      <LeftActionBar>
        <ItemAutoComplete
          placeholder={t("placeholder.select", { item: t("item.item") })}
          variant="filled"
          getItemType={[
            ItemsGet200ResponseRowsInnerItemTypeEnum.MATERIAL,
            ItemsGet200ResponseRowsInnerItemTypeEnum.SEMI_PRODUCT,
            ItemsGet200ResponseRowsInnerItemTypeEnum.SUBSIDIARY,
          ]}
          style={{ flex: 1 }}
          onChange={(e) => handleItemCodeChange(e)}
          value={state.itemCodeValue}
        />
        <LotAutoComplete
          placeholder={t("placeholder.select", { item: t("lot.lot") })}
          style={{ flex: 1 }}
          variant="filled"
          itemCodeValue={state.itemCodeValue ?? ""}
          onChange={(e) => actions.setLotId(e ?? "")}
          value={state.lotId}
        />
      </LeftActionBar>
      {/* <RightActionBar>
                <Input
                    placeholder="바코드를 찍어주세요"
                    value={lotId as string}
                    onKeyDown={handleKeyDown}
                    data-autofocus
                />
                <Button
                    onClick={() =>
                        openModal("", "", "")
                    }
                >
                    추적
                </Button>
            </RightActionBar> */}
    </ActionBarContainer>
  );
};

const ActionBarContainer = styled.div`
  display: flex;
  padding: 8px 0;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
  row-gap: 16px;
  align-self: stretch;
  flex-wrap: wrap;
  background: inherit;
`;

const LeftActionBar = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const RightActionBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 8px;
`;
